import { makeStyles } from 'tss-react/mui'

export const useCommonStyles = makeStyles()({
  hideScrollbar: {
    // Chrome, Safari and Opera
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    // IE and Edge
    msOverflowStyle: 'none',
    // Firefox
    scrollbarWidth: 'none',
  },
})
